import React from 'react';
import { Translation, getI18n } from 'react-i18next';
import { Breadcrumb, Typography, Button } from 'antd';
import { arrowLeft } from '../../../elements/components/Icons';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { pathTo } from '../../../Routes';
import { CheckCircleFilled } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';

const { Title } = Typography;

const LearningModuleStepsHeader = ({
  activeId,
  title,
  titleMain,
  state,
  patch,
  moduleId,
  ...props
}) => {
  const goBack = () => {
    props.history.push(pathTo('LearningScreen', { id: activeId }));
  };

  const markCompleted = () => {
    patch(moduleId, { state: 2 }, (success) => {
      if (success) {
        notification.success(
          getI18n().t('learning_module_mark_completed_success')
        );
      } else {
        notification.error(
          getI18n().t('learning_module_mark_completed_failure')
        );
      }
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div className='learning-module-learning-step-header'>
            <Button
              className='icon-button'
              type='text'
              icon={arrowLeft(10, 17)}
              onClick={goBack}
            />
            <div className='breadcrumb-wrapper'>
              <Breadcrumb>
                <Breadcrumb.Item onClick={goBack} className='cursor-pointer'>
                  {t('learning_breadcrumb_learning')}
                </Breadcrumb.Item>
                <Breadcrumb.Item>{title}</Breadcrumb.Item>
              </Breadcrumb>
            </div>

            {state !== 2 ? (
              <Button
                size='large'
                type='primary'
                className='align-right-button'
                onClick={markCompleted}
              >
                {t('learning_module_mark_completed')}
              </Button>
            ) : (
              <div className='status-completed align-right-button'>
                <CheckCircleFilled className='status-icon' />
                <span className='status-text'>
                  {t('learning_module_state_completed')}
                </span>
              </div>
            )}
          </div>

          <Title level={3} className='learning-module-learning-steps-title'>
            {titleMain}
          </Title>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleStepsHeader);

Logger.log('silly', `LearningModuleStepsHeader loaded.`);
